export type AiCostCallRowPayload = {
	readonly id: number;
	readonly occurredAt: string;
	readonly usage: { readonly value: string; readonly label: string };
	readonly facility: { readonly id: number; readonly label: string | null };
	readonly user: { readonly id: number | null; readonly label: string | null };
	readonly model: { readonly id: number | null; readonly label: string };
	readonly cost: { readonly amount: number | null; readonly isEstimatedAfterwards: boolean };
	readonly quantities: {
		readonly inputTokens: number | null;
		readonly outputTokens: number | null;
		readonly cachedInputTokens: number | null;
		readonly cacheWriteTokens: number | null;
		readonly totalTokens: number | null;
		readonly audioSeconds: number | null;
	} | null;
	readonly related: {
		readonly kind: 'document' | 'interview';
		readonly id: number;
		readonly label: string | null;
		readonly date: string | null;
		readonly interviewKind: { readonly value: 'conversation' | 'notes'; readonly label: string } | null;
	} | null;
};

export type AiCostCallsFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly AiCostCallRowPayload[];
};

export type AiCostCallsFetchedAction = {
	type: 'AI_COST_CALLS_FETCHED';
	payload: AiCostCallsFetchedPayload;
	accountId: number;
	queryKey: string;
	page: number;
};

export default (
	payload: AiCostCallsFetchedPayload,
	accountId: number,
	queryKey: string,
	page: number,
): AiCostCallsFetchedAction => ({
	type: 'AI_COST_CALLS_FETCHED',
	payload,
	accountId,
	queryKey,
	page,
});
